import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer'
import { TEETH, getTpJaw, jawTypes, formatKeyframe } from 'Ui/Components/specsMobileUtils'

const SPE = ['torque', 'lingualVestibular', 'extrusionIntrusion', 'tip', 'distalMesial', 'rotation']

export const MovementsMobile = props => {

    const
        {
            teeth,
            spe,
            jaw,
            setJaw,
            getNumeric,
            getTpJaw,
            mvt
        } = props,
        toothMatrix = [
            {
                teeth: teeth[jaw].ant,
                title: ihm_viewer__dictionary.ANT_SECTOR[locale()],
            },
            {
                teeth: teeth[jaw].post,
                title: ihm_viewer__dictionary.POST_SECTOR[locale()],
            }
        ]

    const labels = i =>
        <div className="labels" key={'label-cont' + i}>
            {spe.map((special, ii) =>
                <div
                    className="labelItem"
                    key={`labelItems-${i}-${ii}`}
                >
                    {ihm_viewer__dictionary.SPE_MOVEMENTS_ITEMS[special.toUpperCase() + '_SHORT'][locale()]}
                </div>
            )}
        </div>

    return (
        <section className="specsMobile">
            <header>
                <h3>
                    {ihm_viewer__dictionary['SPE_MOVEMENTS'][locale()]}
                    <br/>
                    <span>{ihm_viewer__dictionary['SPE_TOTAL'][locale()]}</span>
                </h3>
                <div className="SpecificationMember">
                    { mvt.map( jawId =>
                        <div
                            className={(jaw === getTpJaw(jawId).name) ? 'selected': null}
                            onClick={() => setJaw(getTpJaw(jawId).name)}
                            key={jawId}
                        >
                            {ihm_viewer__dictionary[getTpJaw(jawId).TRANS][locale()]}
                        </div>
                    )}
                </div>
            </header>

            <div className="flexContainer">
                {toothMatrix.map((el, i) =>
                    <div className="flexItem" key={'flexItem' + i}>
                        <h4>{el.title}</h4>
                        <div className="containerSpec">
                            {labels(i)}
                            <div className="containerTable">
                                <table>
                                    <thead>
                                        <tr>
                                            {el.teeth.map((el, teethIndex) =>
                                                [
                                                    teethIndex > 0 ? <th className="separator" key={`th-sep-${teethIndex}`}/> : null,
                                                    el.map(item => <th key={`th-${item}`}>{item}</th>)
                                                ]
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {spe.map((special, lineIndex) =>
                                        <tr key={'line-' + lineIndex}>
                                            {el.teeth.map((el, teethIndex) =>
                                                [
                                                    teethIndex > 0 ? <td className="separator" key={`td-sep-${teethIndex}`}/> : null,
                                                    el.map( tooth =>
                                                        <td key={`td-${tooth}-${lineIndex}-${teethIndex}`}>
                                                            { getNumeric('TOTAL', special, tooth, 'mvts' ) }
                                                        </td>
                                                    )
                                                ]
                                            )}
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    )
}

export const MobileMovementsSection = () => {
    const { AnimationReducer } = useSelector(s => s)
    const mvtContent = AnimationReducer.metas?.treatment?.mvt
    const mvt = mvtContent && mvtContent !== 'none' ? jawTypes(mvtContent) : []
    const [jaw, setJaw] = useState(mvt.includes('upper') ? 'tpUpper' : 'tpLower')

    if (mvt.length === 0) return null

    const keyframe = formatKeyframe(AnimationReducer.keyframe)

    const getNumeric = (sect, special, tooth) => {
        const sector = sect !== 'TOTAL' ? 'step_' + keyframe : 'totalAmount'
        const container = AnimationReducer.metas.treatmentPlanning?.[jaw]?.[sector]
        if (!container?.['toothID_' + tooth]?.mvts?.[special]) return false
        const nb = Number.parseFloat(container['toothID_' + tooth].mvts[special])
        if (nb < -99999 || nb > 99999) return false
        const result = nb.toFixed(1)
        return result !== '0.0' && result !== '-0.0' ? result : false
    }

    return (
        <MovementsMobile
            teeth={TEETH}
            spe={SPE}
            jaw={jaw}
            setJaw={setJaw}
            getNumeric={getNumeric}
            getTpJaw={getTpJaw}
            mvt={mvt}
        />
    )
}
